module.exports = __webpack_public_path__ + "static/img/girl-3.3045c434.png";